export const STANDARD_FORMATS = {
  date: 'yyyy-MM-dd',
  percent: '1.0-2',
};
